import "./../../index.css";
import { useState, Fragment } from "react";
import NumberFormat from "react-number-format";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  createDispatchItem,
  updateDispatchItem,
  deleteDispatchItem,
  setTotalDispatchItem,
} from "../../store/DispatchItem/dispatchItem.action";
import { numberFormat } from "../../utils/utils";

const PurityCalculator = () => {
  const dispatchItem = useSelector((state) => state.dispatchItem, shallowEqual);
  const bookings = useSelector((state) => state.booking, shallowEqual);
  const dispatch = useDispatch();

  const [firstPurity, setFirstPurity] = useState(99.5);
  const [secondPurity, setSecondPurity] = useState(99.9);
  const [thirdPurity, setThirdPurity] = useState(100);
  const [balanceSettlementAmount, setBalanceSettlementAmount] = useState(0);
  const [balanceMetal, setBalanceMetal] = useState(0);
  const [avgBookingRate, setAvgBookingRate] = useState(0);

  const handlePurityAddFields = () => {
    dispatch(createDispatchItem());
  };

  const handlePurityRemoveFields = (rowId) => {
    dispatch(deleteDispatchItem(rowId));
  };

  const handlePurityInputChange = (index, fieldName, event) => {
    let tempDispatchItem = [...dispatchItem.dispatchItemDetails];

    if (fieldName === "itemPurity") {
      tempDispatchItem[index].itemPurity = event.target.value;
    } else if (fieldName === "itemPureWeight") {
      tempDispatchItem[index].itemPureWeight = event.value;
    } else if (fieldName === "itemWeight") {
      tempDispatchItem[index].itemWeight = event.value;
    } else if (fieldName === "noOfPieces") {
      tempDispatchItem[index].noOfPieces = event.target.value;
    } else if (fieldName === "token") {
      tempDispatchItem[index].token = event.target.value;
    }

    calcPureWeight(index);

    tempDispatchItem[index].itemPurity =
      tempDispatchItem[index].itemPurity >= 100
        ? tempDispatchItem[index].itemPurity / 10
        : tempDispatchItem[index].itemPurity;
    calcTotal();
    dispatch(updateDispatchItem(tempDispatchItem));
  };

  const calcPureWeight = (index) => {
    dispatchItem.dispatchItemDetails[index].itemPureWeight = (
      (dispatchItem.dispatchItemDetails[index].itemPurity *
        dispatchItem.dispatchItemDetails[index].itemWeight) /
      100
    ).toString();
  };

  const calcTotal = () => {
    let totalWeight = 0,
      totalPureWeight = 0;

    dispatchItem.dispatchItemDetails.forEach((ele) => {
      totalPureWeight += parseFloat(ele.itemPureWeight);
      totalWeight += parseFloat(ele.itemWeight);
    });

    dispatch(
      setTotalDispatchItem({
        totalWeight: totalWeight,
        totalPureWeight: totalPureWeight,
      })
    );

    // booking total pure weight - gathered total pure weight
    setBalanceMetal(
      Number(bookings.avgBookingDetails.averagePureWeight) - totalPureWeight
    );

    //avg rate * balance metal need to cut
    setBalanceSettlementAmount(
      bookings.avgBookingDetails.averageRate *
        (bookings.avgBookingDetails.averagePureWeight - totalPureWeight)
    );

    setAvgBookingRate(bookings.avgBookingDetails.averageRate);
  };

  const handlePurityFields = (position, event) => {
    let value = event.target.value;
    position === "first"
      ? setFirstPurity(value)
      : position === "second"
      ? setSecondPurity(value)
      : setThirdPurity(value);
  };

  const calcBalMetal = (balanceMetal, purity) => {
    return numberFormat(balanceMetal * (purity / 100), 3);
  };

  return (
    <div>
      <div className="card card-1">
        <h5>BALANCE METAL</h5>
        <table className="table">
          <thead>
            <tr>
              <th>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  id="purity"
                  name="purity"
                  placeholder="99.5"
                  value={firstPurity}
                  onChange={(event) => handlePurityFields("first", event)}
                />
              </th>
              <th>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  id="purity"
                  name="purity"
                  placeholder="99.9"
                  value={secondPurity}
                  onChange={(event) => handlePurityFields("second", event)}
                />
              </th>
              <th>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  id="purity"
                  name="purity"
                  placeholder="100"
                  value={thirdPurity}
                  onChange={(event) => handlePurityFields("third", event)}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              className={
                calcBalMetal(balanceMetal, firstPurity) >= 0.0 &&
                calcBalMetal(balanceMetal, firstPurity) <= 0.1
                  ? "success"
                  : calcBalMetal(balanceMetal, firstPurity) >= 0.1 &&
                    calcBalMetal(balanceMetal, firstPurity) <= 0.2
                  ? "warning"
                  : "error"
              }
            >
              <td>{calcBalMetal(balanceMetal, firstPurity)}</td>
              <td>{calcBalMetal(balanceMetal, secondPurity)}</td>
              <td>{calcBalMetal(balanceMetal, thirdPurity)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <button
          className="btn btn-outline-primary"
          type="button"
          onClick={() => handlePurityAddFields()}
          style={{ float: "right" }}
        >
          + Add
        </button>
      </div>
      {dispatchItem.dispatchItemDetails.map((purityField, index) => (
        <Fragment key={`${purityField}~${index}`}>
          <div className="form-group col-sm-10 tableDesign">
            <table>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="number"
                      step="1"
                      className="form-control"
                      placeholder="Token No"
                      id="token"
                      name="token"
                      value={purityField.token}
                      onChange={(event) =>
                        handlePurityInputChange(index, "token", event)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      step="1"
                      className="form-control"
                      placeholder="Pieces"
                      id="noOfPieces"
                      name="noOfPieces"
                      value={purityField.noOfPieces}
                      onChange={(event) =>
                        handlePurityInputChange(index, "noOfPieces", event)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      placeholder="Purity"
                      id="itemPurity"
                      name="itemPurity"
                      suffix={" %"}
                      value={purityField.itemPurity}
                      onChange={(event) =>
                        handlePurityInputChange(index, "itemPurity", event)
                      }
                    />
                  </td>
                  <td>
                    <NumberFormat
                      value={purityField.itemWeight}
                      className="form-control"
                      thousandSeparator={true}
                      thousandsGroupStyle="lakh"
                      decimalSeparator="."
                      decimalScale={3}
                      suffix={" g"}
                      id="itemWeight"
                      placeholder="Weight"
                      name="itemWeight"
                      allowNegative={false}
                      onValueChange={(event) =>
                        handlePurityInputChange(index, "itemWeight", event)
                      }
                    />
                  </td>
                  <td>
                    <NumberFormat
                      value={purityField.itemPureWeight}
                      className="form-control"
                      thousandSeparator={true}
                      thousandsGroupStyle="lakh"
                      decimalSeparator="."
                      decimalScale={3}
                      suffix={" g"}
                      id="itemPureWeight"
                      placeholder="Pure Weight"
                      name="itemPureWeight"
                      allowNegative={false}
                      onValueChange={(event) =>
                        handlePurityInputChange(index, "itemPureWeight", event)
                      }
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      hidden={index === 0}
                      onClick={() =>
                        handlePurityRemoveFields(purityField.rowId)
                      }
                    >
                      -
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="form-group col-sm-2"></div>
        </Fragment>
      ))}
      {dispatchItem.dispatchItemDetails.length >= 2 && (
        <div className="tableDesign">
          <table className="table table-bordered border-primary">
            <thead>
              <tr>
                <th>#</th>
                <th scope="col">Total Weight</th>
                <th scope="col">Total Pure Weight</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td></td>
                <td>
                  {numberFormat(
                    dispatchItem.totalDispatchedItemDetails.totalWeight,
                    3
                  )}{" "}
                  grams
                </td>
                <td>
                  {numberFormat(
                    dispatchItem.totalDispatchedItemDetails.totalPureWeight,
                    3
                  )}{" "}
                  grams
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      <div>
        <p>
          <span>
            {"  "}
            {numberFormat(avgBookingRate, 2)}
          </span>{" "}
          x <span>{numberFormat(balanceMetal, 3)}</span> = To be{" "}
          {balanceSettlementAmount > 0 ? "Pay" : "Receive"}{" "}
          <span>
            {balanceSettlementAmount >= 0 && balanceSettlementAmount <= 15
              ? 0
              : numberFormat(balanceSettlementAmount, 2)}
          </span>
        </p>
        <p></p>
      </div>
    </div>
  );
};

export default PurityCalculator;
